module.exports = "../study/imgs/notfound.svg";